import React from "react";

type StackedAvatarsProps = {
  images: [string, string, string];
  size?: number;        // diameter in px
  overlap?: number;     // how much each avatar slides into the previous (px)
  borderWidth?: number; // ring that creates the tiny gap
  borderColor?: string;
};

const StackedAvatars: React.FC<StackedAvatarsProps> = ({
  images,
  size = 48,
  overlap = 10,
  borderWidth = 2,
  borderColor = "#fff",
}) => {
  const ring = `${borderWidth}px solid ${borderColor}`;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {images.map((src, i) => (
        <img
          key={i}
          src={src}
          alt=""
          style={{
            width: size,
            height: size,
            borderRadius: "50%",
            objectFit: "cover",
            border: ring,                 // creates the tiny space between overlaps
            boxShadow: "0 0 0 1px rgba(0,0,0,0.06)",
            marginLeft: i === 0 ? 0 : -overlap,
          }}
        />
      ))}
    </div>
  );
};

export default StackedAvatars;
